import {
	getTelegramInitData,
} from '../../utils/telegram'
import type {
	HttpService,
} from './http.service'
import type {
	IHttpConfig,
	IMap,
} from './http.types'

export class EnhancedWithTelegramHttpService {
	constructor(private readonly httpService: HttpService) {
		this.httpService = httpService
	}

	public createQueryLink(base: string, parameters: IMap): string {
		return this.httpService.createQueryLink(base, parameters)
	}

	public async get<T>(url: string, config: IHttpConfig = {
	}): Promise<T> {
		return this.httpService.get<T>(url, this.attachTelegramHeader(config))
	}

	public async post<T, TD>(url: string, data: TD, config: IHttpConfig = {
	}): Promise<T> {
		return this.httpService.post<T, TD>(url, data, this.attachTelegramHeader(config))
	}

	public async put<T, TD>(url: string, data: TD, config: IHttpConfig = {
	}): Promise<T> {
		return this.httpService.put<T, TD>(url, data, this.attachTelegramHeader(config))
	}

	public async patch<T, TD>(url: string, data: TD, config: IHttpConfig = {
	}): Promise<T> {
		return this.httpService.patch<T, TD>(url, data, this.attachTelegramHeader(config))
	}

	public async delete<T>(url: string, config: IHttpConfig = {
	}): Promise<T> {
		return this.httpService.delete<T>(url, this.attachTelegramHeader(config))
	}

	private attachTelegramHeader(config: IHttpConfig): IHttpConfig {
		return {
			...config,
			headers: {
				...config.headers,
				...this.populateTelegramHeaderConfig(),
			},
		}
	}

	private populateTelegramHeaderConfig(): Record<string, string> {
		const initData = getTelegramInitData()

		if (!initData) {
			return {
			}
		}

		return {
			'X-Telegram-Init-Data': initData,
		}
	}
}
